import {IAutoBackupIsLoadingSetAction} from './types';
import {AT_AUTO_BACKUPS_IS_LOADING_SET} from './constants';

export const autoBackupIsLoadingSet = (
    isLoading: boolean
): IAutoBackupIsLoadingSetAction => ({
    type: AT_AUTO_BACKUPS_IS_LOADING_SET,
    isLoading
});
